'use client';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/navigation';
import AppLayout from '@/components/layout/app-layout';
import LoadingIndicator from '@/components/shared/loading-indicator';
import { useCourses } from '@/providers';

export default function Page() {
  const router = useRouter();
  const { courses, isLoading } = useCourses();

  if (isLoading) {
    return (
      <AppLayout>
        <LoadingIndicator label="Kurse werden geladen..." />
      </AppLayout>
    );
  }

  const onCourseClick = (courseSlug: string) => {
    router.push(`/kurs/${courseSlug}`);
  };

  return (
    <AppLayout>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          mt: 3,
          px: 3,
          mx: 'auto',
        }}>
        {courses?.map((course) => (
          <Card
            className={course.theme}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: { xs: '100%', sm: '48%', md: '31%' },
              maxWidth: 280,
              boxShadow: '0 5px 20px 0 rgba(0,0,0,0.13)',
              borderRadius: '10px',
              margin: { xs: '0 auto 20px', sm: '0 15px 25px 0' },
              backgroundColor: (theme) => theme.palette.grey[800],
              '&.psy-at-fw, &.gradient-green': {
                backgroundImage: 'linear-gradient(-135deg, #62D97F 0%, #30AC8B 100%)',
              },
              '&.psy-at-fd, &.gradient-blue': {
                backgroundImage: 'linear-gradient(-135deg, #6FC6F0 0%, #6F69FA 100%)',
              },
              '&.psy-at-fp, &.gradient-orange': {
                backgroundImage: 'linear-gradient(-135deg, #fb8745 0%, #d02811 100%)',
              },
              '&.psy-at-et, &.gradient-turquoise': {
                backgroundImage: 'linear-gradient(-135deg, #2BD7CC 0%, #248797 100%)',
              },
              '&.psy-at-ts, &.gradient-violet': {
                backgroundImage: 'linear-gradient(-135deg, #8D58F5 0%, #511BA6 100%)',
              },
              '&.psy-at-ts-light, &.gradient-violet-light': {
                backgroundImage:
                  'linear-gradient(-135deg,rgb(201, 175, 252) 0%,rgb(113, 78, 169) 100%)',
              },
              '&.psy-at-paket, &.gradient-purple': {
                backgroundImage: 'linear-gradient(-135deg, #b531d9, #8d2a87);',
              },
            }}
            key={course.id}>
            <CardActionArea onClick={() => onCourseClick(course.slug)}>
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  sx={{
                    color: 'white',
                  }}>
                  {course.title}
                </Typography>
                {course.description && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                    sx={{
                      color: 'white',
                    }}>
                    {course.description}
                  </Typography>
                )}
              </CardContent>
            </CardActionArea>
            <CardActions
              sx={{
                marginTop: 'auto',
              }}>
              <Button
                size="medium"
                variant="outlined"
                sx={{
                  width: '100%',
                  color: 'white',
                  borderColor: 'white',
                }}
                onClick={() => onCourseClick(course.slug)}>
                Kurs öffnen
              </Button>
            </CardActions>
          </Card>
        ))}
      </Box>
    </AppLayout>
  );
}
